import * as React from "react";
import { cn } from "@/lib/utils";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => <input ref={ref} className={cn("h-11 w-full rounded-lg border border-input bg-background px-3.5 text-sm outline-none transition-shadow placeholder:text-muted-foreground focus:border-primary focus:ring-3 focus:ring-primary/15", className)} {...props} />,
);
Input.displayName = "Input";

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => <textarea ref={ref} className={cn("min-h-28 w-full resize-y rounded-lg border border-input bg-background px-3.5 py-3 text-sm outline-none transition-shadow placeholder:text-muted-foreground focus:border-primary focus:ring-3 focus:ring-primary/15", className)} {...props} />,
);
Textarea.displayName = "Textarea";
